import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ROUTE_NAMES, RouterService } from '@go-modules/services/router/router.service';
import { GoToastStatusType } from '@go-modules/enums/go-toast-status-type';
import { NgxGoToastService } from '@go-modules/services/go-toast/go-toast.service';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';

export interface TrialSuccessDialogData {
	folder_id?: string;
	dialogTitleId?: string;
}

@Component({
	selector: 'app-ai-trial-success-dialog',
	templateUrl: './ai-trial-success-dialog.component.html',
	styleUrls: ['./ai-trial-success-dialog.component.scss'],
	standalone: false
})
export class AiTrialSuccessDialogComponent {
	// A small helper to open the dialog with all the correct typing
	public static open (
		dialog: MatDialog,
		config: MatDialogConfig<TrialSuccessDialogData>
	): MatDialogRef<AiTrialSuccessDialogComponent> {
		const dialogTitleId = config?.data?.dialogTitleId ?? AiTrialSuccessDialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, AiTrialSuccessDialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `ai-trial-success-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	public constructor (
		public dialogRef: MatDialogRef<AiTrialSuccessDialogComponent>,
		private ngxGoToastService: NgxGoToastService,
		@Inject(MAT_DIALOG_DATA) public data: TrialSuccessDialogData,
		private routerService: RouterService
	) {
		this.dialogRef.afterClosed().subscribe(() => this.showToast(this.data.folder_id));
		this.data.dialogTitleId ??= AiTrialSuccessDialogComponent.getDialogTitleId();
	}

	public close () {
		this.dialogRef.close();
	}

	private showToast (folder_id: string) {
		this.ngxGoToastService.createToast({
			type: GoToastStatusType.SUCCESS,
			message: 'ai-trial-success-dialog_toast',
			actionLink:{
				title: 'ai-trial-success-dialog_action_link',
				action: () => this.routerService.navigateTo(ROUTE_NAMES.DASHBOARD_FOLDER_VIEW, {folder_id})
			}
		});
	}
}
